import { Component } from '@angular/core';

import { BaseEligibilityQuestionsComponent } from '../base-eligibility-questions.component';

@Component({
  selector: 'boi-advised-residential-questions',
  templateUrl: './advised-residential-questions.component.html',
  styleUrls: ['./advised-residential-questions.component.scss']
})
export class AdvisedResidentialQuestionsComponent extends BaseEligibilityQuestionsComponent {
  public changeIsRemortgage(isRemortgage: string): void {
    this.caseSetup.IsRemortgage = isRemortgage;
    this.isValidChange.emit(this.checkValidity());
  }

  public checkValidity(): boolean {
    for (const question of this.questions) {
      if (!question.ProvidedAnswer) {
        return false;
      }
    }

    if (!this.caseSetup.PropertyLocation || !this.caseSetup.IsRemortgage) {
      return false;
    }

    return true;
  }
}
